<template>

  <ion-footer :style="styleHeight" >
    <div style="display: inline;" v-for="item in elements" v-bind:key="item.index">
      <ion-button size="small" class="ion-text-wrap button-color"
                  :disabled="item.disabled" :style="styleHeight"
                  :class="{ button_count_1 : elements.length == 1 ,
                    button_count_2 : elements.length == 2 ,
                    button_count_3 : elements.length == 3 ,
                    button_count_4 : elements.length == 4 ,
                    button_count_5 : elements.length == 5 ,
                    button_count_6 : elements.length == 6 ,
                    button_count_7 : elements.length == 7 
                  }"

                  @click="tabClick(item.index)">
          {{ item.label }}
          <span v-if="item.icon != undefined" >
            <ion-icon aria-hidden="true" :icon="item.icon" />
          </span>
          <span v-if="item.hasAction != undefined && item.hasAction && !showBigButtons" >
            <ion-icon aria-hidden="true" :icon="caretUpOutline" />
          </span>
          <!-- <span v-if="item.actionOpen != undefined && item.actionOpen == true" >
            <ion-icon aria-hidden="true" :icon="caretDownOutline" />
          </span> -->
      </ion-button>

    </div>
  </ion-footer>

</template>


// https://stackoverflow.com/questions/57557068/click-event-not-working-on-majority-of-elements-on-page-ionic-4

<script setup >

import { IonIcon,IonButton, IonFooter} from '@ionic/vue';
import { caretBackOutline,caretForwardOutline, caretUpOutline , caretDownOutline } from 'ionicons/icons';
import { useConnectionStore } from '@/stores/connectionStore';

import { ref, watch } from 'vue'

import { computed } from "@vue/reactivity"

const props = defineProps({
  elements : Array,
  ignoreClicks : {
    type : Boolean,
    default : false
  },

  trigger : Number
})

const connectionStore = useConnectionStore()

const whichMenu = localStorage.getItem("whichMenu")
const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)

var footerHeight = connectionStore.getToolbarHeight
//console.log("Foot height ",footerHeight)
if (showBigButtons.value)
  footerHeight = Math.floor(footerHeight * connectionStore.getToolbarScalePercentage / 100.0)

//console.log("Foot height ",footerHeight)

const styleHeight = ref("height:" + footerHeight + "px;")

const trigger = computed({ get() { return props.trigger }})
const elements = computed({ get() { return props.elements }})

const emit = defineEmits(['toolbar-click'])

function tabClick(index) {

  if (props.ignoreClicks)
    return
  
  emit("toolbar-click",index)
}
</script>

<style scoped>

.button_count_1 {
  width : 98%;
  padding-left: 1%;
  padding-right : 1%;
}
.button_count_2 {
  width : 48%;
  padding-left: 1%;
  padding-right : 1%;
}

.button_count_3 {
  width : 31.3%;
  padding-left: 1%;
  padding-right : 1%;
}
.button_count_4 {
  width : 23%;
  padding-left: 1%;
  padding-right : 1%;
}

.button_count_5 {
  width : 18%;
  padding-left: 1%;
  padding-right : 1%;
}

.button_count_6 {
  width : 14.6%;
  padding-left: 1%;
  padding-right : 1%;
}
.button_count_7 {
  width : 12.2%;
  padding-left: 1%;
  padding-right : 1%;
}

ion-button {
  text-transform: none;
 }

 ion-footer {
    --background: lightgray;
    --color: #fff;
  }

.button-color {
  --background :#558AF7;
}
.button-color:hover {
  --background : #76a1f8;
}

</style>
